import { gql } from '@apollo/client';
import ACADEMIC_SESSION_FRAGMENT from './academic-session';
import EXTERNAL_ID_FRAGMENT from './external-id';
const ORGANIZATION_FRAGMENT = gql`
  fragment BaseOrganization on Organization {
    id
    externalId {
      ...BaseExternalId
    }
    sisId
    ncesId
    mdrNumber
    name
    type
    address
    city
    state
    zip
    parentOrganizationId
    academicSessions {
      ...BaseAcademicSession
    }
  }
  ${ACADEMIC_SESSION_FRAGMENT}
  ${EXTERNAL_ID_FRAGMENT}
`;

export default ORGANIZATION_FRAGMENT;
